import { useBreakpoint } from '@react-spectrum/utils';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Pagination } from '@exchange-frontends/components';
import { useStaticData } from '@exchange-frontends/custom-hooks';

import usePublisherApps from '../../../../../actions/myxchngApi/selectors/usePublisherApps';
import { ROUTES } from '../../../../../constants';
import PublisherAppsGrid from './PublisherAppsGrid';
import CloudAppCard from '../../../../components/CloudAppCard';

const PublisherAppsTabContent = ({ type }) => {
  const { matchedBreakpoints } = useBreakpoint();
  const productsLocs = useStaticData('hostApps');
  const [searchParams, setSearchParams] = useSearchParams();
  const { activeQuery, page, isLoading } = usePublisherApps({
    type,
    refetchOnMount: false,
    keepPreviousData: false,
  });

  const shownApps = activeQuery.data?.cloudApps;
  const totalPages = activeQuery.data?.totalPages;

  if (isLoading) {
    return (
      <PublisherAppsGrid>
        {Array.from({ length: 6 }).map((_, index) => (
          <CloudAppCard key={`skeleton-${index}`} ROUTES={ROUTES} loading />
        ))}
      </PublisherAppsGrid>
    );
  }

  return (
    <>
      <PublisherAppsGrid>
        {shownApps?.map((app) => (
          <CloudAppCard
            key={app.id}
            headerId="By this publisher"
            cloud={type}
            app={app}
            ROUTES={ROUTES}
            productsLocs={productsLocs}
          />
        ))}
      </PublisherAppsGrid>
      {totalPages > 1 && (
        <Pagination
          enablePageNumbers={matchedBreakpoints.includes('S') ? true : false}
          defaultPage={page}
          totalPages={totalPages}
          onChange={
            /** @param {number} page */
            (page) => {
              window.scrollTo(0, 0);
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.set('page', page.toString());
              setSearchParams(newSearchParams);
            }
          }
        />
      )}
    </>
  );
};

export default PublisherAppsTabContent;
